import { useGetDomainConfigQuery } from "@callveriq/redux/services/domain/domain.service";
import { AttributeBlockFormType } from "../../../../types/bert";
import { useGetCallTypesQuery } from "@callveriq/redux/services/settings/callTypeManager.service";
import { useGetCallTagsQuery } from "@callveriq/redux/services/settings/callTagsManager.service";
import {
    useGetDispositionByTemplateIdQuery,
    useGetDispositionTemplateListQuery,
    useGetLevelsByDispositionIdQuery,
} from "@callveriq/redux/services/settings/aiDisposition.service";
import { useGetCustomEntitiesQuery } from "@callveriq/redux/services/settings/entity.service";
import { useGetTeamsQuery } from "@callveriq/redux/services/settings/teamManager.service";

export const useAttributeData = (nodeDataToUpdate: AttributeBlockFormType) => {
    const { data: domainConfig } = useGetDomainConfigQuery();

    const meetingTypeOptions = domainConfig?.getConversationTypeOptions() ?? [];

    const attribute_type = nodeDataToUpdate?.attribute_type;

    const { data: callTypes, isLoading: isTypesLoading } = useGetCallTypesQuery(
        undefined,
        { skip: attribute_type !== "type" }
    );

    const { data: teams, isLoading: isTeamsLoading } = useGetTeamsQuery(
        undefined,
        { skip: attribute_type !== "team" }
    );

    const { data: callTags, isLoading: isTagsLoading } = useGetCallTagsQuery(
        undefined,
        { skip: attribute_type !== "tags" }
    );

    const { data: level1 } = useGetDispositionByTemplateIdQuery(
        nodeDataToUpdate?.ai_disposition ?? 0,
        { skip: !nodeDataToUpdate?.disposition_levels?.level1 }
    );

    const level1Id = nodeDataToUpdate?.disposition_levels?.level1;
    const level2Id = nodeDataToUpdate?.disposition_levels?.level2;

    const { data: level2 } = useGetLevelsByDispositionIdQuery(level1Id || 0, {
        skip: !level1Id,
    });

    const { data: level3 } = useGetLevelsByDispositionIdQuery(level2Id || 0, {
        skip: !level2Id,
    });

    const { data: aiDispositionTemplates } = useGetDispositionTemplateListQuery(
        { isArchive: false },
        { skip: !nodeDataToUpdate?.ai_disposition }
    );

    const { data: entities, isLoading: isEntitiesLoading } =
        useGetCustomEntitiesQuery();
    const entityValue =
        entities?.find((item) => item.id === nodeDataToUpdate?.attribute_entity)
            ?.name ?? null;

    const dispositionTemplateValue =
        aiDispositionTemplates?.find(
            (item) => item.id === nodeDataToUpdate?.ai_disposition
        )?.name ?? null;

    const level1Value =
        level1?.find(
            (item) => item.id === nodeDataToUpdate?.disposition_levels?.level1
        )?.name ?? null;

    const level2Value =
        level2?.find(
            (item) => item.id === nodeDataToUpdate?.disposition_levels?.level2
        )?.name ?? null;

    const level3Value =
        level3?.find(
            (item) => item.id === nodeDataToUpdate?.disposition_levels?.level3
        )?.name ?? null;

    return {
        meetingTypeOptions,
        attribute_type,
        callTypes,
        callTags,
        teams,
        isTeamsLoading,
        isTypesLoading,
        isTagsLoading,
        isEntitiesLoading,
        level1,
        level2,
        level3,
        aiDispositionTemplates,
        entities,
        level1Value,
        level2Value,
        level3Value,
        entityValue,
        dispositionTemplateValue,
    };
};
